import React, { FC } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import NavigationMenu from '../NavigationMenu';
import { getRoutes } from './getRoutes';
import { Header } from '../Header';
import styles from './styles.module.css';
import { useAuth0 } from '../../../Auth';
import { StopScreen } from '../StopScreen/StopScreen';
import { useRewardsEnrollment } from 'Shared/hooks';
import { LoadingPage } from 'Shared/components';
import { useSurvicate } from 'Shared/hooks/useSurvicate/useSurvicate';

export const Core: FC = () => {
  useSurvicate();

  const { user } = useAuth0();

  const rewardsEnrollment = useRewardsEnrollment();

  if (
    !user ||
    !rewardsEnrollment ||
    rewardsEnrollment.rewardsEnrollmentLoading
  ) {
    return <LoadingPage />;
  }

  const routes = getRoutes({
    user,
    rewardsEnrollment,
  });

  return (
    <>
      <NavigationMenu
        navItems={routes.map(({ component, ...navProps }) => ({
          ...navProps,
        }))}
      />
      <div className={styles.container}>
        <Header />
        <main
          role="main"
          className={styles.routeContainer}
          data-testid="core-routes"
        >
          {user.activated ? (
            <Switch>
              {routes.map((item, i) => {
                const Component = item.component;
                return (
                  <Route
                    exact={i === 0} // only exact on home
                    path={item.path}
                    render={props => <Component {...props} />}
                    key={item.path}
                  />
                );
              })}
              <Redirect to="/quotes" />
            </Switch>
          ) : (
            <StopScreen />
          )}
        </main>
      </div>
    </>
  );
};
